<section class="contact"
    style="background: url('assets/img/mask-back.svg'); background-size: cover; background-position: center; background-repeat: no-repeat; padding: 50px 0px 0px 0px;">
    <div class="container">

        <div class="row">
            <div class="col-12 col-sm-4 col-lg-4" style="margin: auto;">
                <h2>Contactez-nous</h2>
                <p>Nous sommes disponibles à tout moment pour tous vos besoins administratifs et professionnels.
                    Contactez-nous
                    maintenant</p>
            </div>
            <div class="col-12 col-sm-8 col-lg-8">
                <div class="contact-card">
                    <h4 class="pays"><img src="assets/img/logo.png">Talents Plus Afrique </h4>
                    <hr>
                    <p><img src="assets/img/location.svg">C/892-Sikècodji-Fignon Cotonou 01 B.P. 5771 Rép. du Bénin
                    </p>
                    <p><img src="assets/img/local-phone.svg">(+229) 21 15 93 17 / 97 64 03 93</p>
                    <p><img src="assets/img/email.svg"> <a
                            href="mailto:info@talentsplusafrique.com">info@talentsplusafrique.com</a></p>
                    <a target="_blank"
                        href="https://www.google.com/maps/place/TALENTS+PLUS+AFRIQUE/@6.3767471,2.4151553,17z/data=!3m1!4b1!4m6!3m5!1s0x10235592a0e0a68d:0x505895d3604b2426!8m2!3d6.3767418!4d2.417344!16s%2Fg%2F11g1gq53js?hl=fr">
                        <p><img src="assets/img/location.svg">Cliquez ici pour la localisation</p>
                    </a>
                </div>

            </div>
        </div>
    </div>
</section>
<section class="form-contact">
    <div class="container">
        <h2 style="margin-bottom:20px;">Ecrivez-nous</h2>
        <form id="myForm" [formGroup]="contactForm" (ngSubmit)="onSubmitContactForm()">
            <div class="row">
                <div class="mb-3 col-md-6" style="">
                    <label class="form-label">Votre nom<span>*</span></label>
                    <input type="text" class="form-control" id="name" formControlName="name" placeholder="Nom**">
                </div>
                <div class="mb-3 col-md-6" style="">
                    <label class="form-label">Votre email<span>*</span></label>
                    <input type="email" class="form-control" id="email" formControlName="email" placeholder="Email**">
                </div>
                <div class="mb-3 col-md-6" style="">
                    <label class="form-label">Sujet<span>*</span></label>
                    <input type="email" class="form-control" id="subject" formControlName="subject"
                        placeholder="Sujet**">
                </div>

                <div class="mb-3 col-md-12">
                    <label for="" class="form-label">Votre message<span>*</span></label>
                    <textarea class="form-control" id="task" rows="4" maxlength="300" formControlName="message"
                        placeholder="Message**"></textarea>
                </div>
                <div class="mb-3 col-md-12" style="">
                    <button type="submit" [disabled]="contactForm.invalid" *ngIf="!formIsLoading"
                        class="btn btn-submit">Envoyer</button>
                    <p class="text-danger" style="padding-top: 15px; margin-left: 15px;" *ngIf="formIsLoading">Veuillez
                        patienter...
                    </p>
                </div>
            </div>
        </form>
    </div>
</section>